module.exports = __webpack_public_path__ + "static/media/velvet.3cd6e3a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/question-images/velvet.jpg
// module id = 134
// module chunks = 0